import React from 'react';
import { brand, ctaLabel, price, topLabel } from '../data/content';
import { handleScrollClick } from './CtaButton';
export function TopBar() {
  return <header className="border-b border-hair bg-white" data-id="element-258" data-mp="234zy51a3u6d3">
      <div className="mx-auto flex h-16 max-w-page items-center justify-between gap-3 px-5 md:px-8" data-id="element-259" data-mp="1y4vcyxy94ngj">
        <a href="#top" className="whitespace-nowrap font-display text-[15px] font-black tracking-tight text-brand md:text-[18px]" data-id="element-260" data-mp="1t5r64dysv1td">
          {brand}
        </a>
        <a href="#offer" onClick={handleScrollClick} data-cta="offer" className="inline-flex h-10 shrink-0 items-center whitespace-nowrap rounded-lg bg-sun px-3 font-display text-[12px] font-extrabold tracking-[0.02em] text-ink transition-colors duration-150 ease-out hover:bg-sun-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand md:px-4 md:text-[13px]" data-id="element-261" data-mp="2lteqbrw5rqfh">
          <span className="sm:hidden" data-id="element-262" data-mp="34qxzcvim991w">{topLabel} · {price}</span>
          <span className="hidden sm:inline" data-id="element-263" data-mp="26aj453ucts3">{ctaLabel}</span>
        </a>
      </div>
    </header>;
}